export { BrandingForm } from './BrandingForm';

// Ory branding
export const polisBranding = {
  logoUrl: '/logo.svg',
  faviconUrl: '/favicon.ico',
  companyName: 'Ory Polis',
  primaryColor: '#4f39f6',
};
